import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import {AppraiserLoadingService} from "../../services/loading/loading.service";

@Component({
  selector: 'loading',
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
  encapsulation: ViewEncapsulation.None,
  exportAs: 'loading',
  standalone: true,
  imports: [NgIf],
})
export class LoaderComponent implements OnChanges, OnInit, OnDestroy {
  @Input() autoMode: boolean = true;
  mode: 'determinate' | 'indeterminate' = 'indeterminate';
  progress: number | null = 0;
  show: boolean = false;
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  /**
   * Constructor
   */
  constructor(private _loadingService: AppraiserLoadingService, private _cdr: ChangeDetectorRef) {
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On changes
   *
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges): void {
    // Auto mode
    if ('autoMode' in changes) {

      // Set the auto mode in the service
      this._loadingService.setAutoMode(coerceBooleanProperty(changes['autoMode'].currentValue));

    }
  }

  /**
   * On init
   */
  ngOnInit(): void {
    // Subscribe to the service
    this._loadingService.mode$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((value) => {

        this.mode = value;
        this._cdr.detectChanges();
      });

    this._loadingService.progress$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((value) => {
        this.progress = value;
        this._cdr.detectChanges();
      });

    this._loadingService.show$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((value) => {

        this.show = value;
        this._cdr.detectChanges();
      });

  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}
